import { useState, useEffect, useMemo } from "react";

const ProductTabs = () => {
  const tabs = useMemo(
    () => ["Overview", "Images", "Specifications", "FAQ's"],
    []
  );
  const [activeTab, setActiveTab] = useState("Overview");
  const [stickyTop, setStickyTop] = useState(0);

  useEffect(() => {
    const header = document.querySelector("header.header");

    const handleResizeAndScroll = () => {
      if (header) {
        const headerHeight = header.offsetHeight;
        const isHeaderVisible = header.classList.contains("visible");
        setStickyTop(isHeaderVisible ? headerHeight : 0);
      }

      // Detect which section is in view
      let currentSection = "";
      tabs.forEach((tab) => {
        const section = document.getElementById(tab.toLowerCase());
        if (section) {
          const rect = section.getBoundingClientRect();
          if (rect.top <= 100 && rect.bottom >= 100) {
            currentSection = tab;
          }
        }
      });

      if (currentSection) {
        setActiveTab(currentSection);
      }
    };

    const resizeObserver = new ResizeObserver(handleResizeAndScroll);
    if (header) {
      resizeObserver.observe(header);
    }

    window.addEventListener("scroll", handleResizeAndScroll);
    handleResizeAndScroll();

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener("scroll", handleResizeAndScroll);
    };
  }, [tabs]);

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      const yOffset = stickyTop - 10;
      const y =
        section.getBoundingClientRect().top + window.pageYOffset - yOffset;

      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  return (
    <div
      className="sticky z-40 bg-gray-200 transition-all duration-500 ease-in-out"
      style={{ top: `${stickyTop}px` }}
    >
      <div className="flex">
        {tabs.map((tab) => (
          <div
            key={tab}
            className={`flex-1 text-center py-3 cursor-pointer transition-all duration-300 ${
              activeTab === tab
                ? "bg-[#cc673d] text-white"
                : "bg-gray-200 text-black hover:bg-[#e47c4f] hover:text-white"
            }`}
            onClick={() => {
              setActiveTab(tab);
              scrollToSection(tab.toLowerCase());
            }}
          >
            {tab}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductTabs;

